import {
  Paper,
  Grid,
  Button,
  Alert,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import React, { useContext } from "react";

import { loadStripe } from "@stripe/stripe-js";

import constant from "../Costanti/Constant.js";
import "dayjs/locale/it";

import dayjs from "dayjs";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { useNavigate } from "react-router-dom";
import InfoUser from "../infoUser";
import { Context } from "../Context.js";
import { StaticDatePicker } from "@mui/x-date-pickers";
import imageLogoFidalIcona from "../img/logoFidalIcona.jpeg";

import "./Abbonamento.css";

const Utenze = {
  ADMIN: 1,
  USER: 2,
};

const Abbonamento = () => {
  const stripePromise = loadStripe(
    "pk_live_51LvMKTIUBaKEna1TVuf3hbmFwVkBBzOEfsm0M7Jp6vsm0i7UsuPG87XyGnD77ANmLPs38bhhKECYn43B0fF9geSL00efgDLihY"
  );
  // const stripePromise = loadStripe("pk_test_...");

  const { nome, setNome, token, setToken, idTipoUtente, setidTipoUtente } =
    useContext(Context);

  const [costoAbbonamento, setCostoAbbonamento] = React.useState(0);
  const [tipoAbbonamento, setTipoAbbonamento] = React.useState("");

  const [bookableField, setBookableField] = React.useState([]);
  const [selectedFields, setSelectedFields] = React.useState([]); // <<< ARRAY, non Set
  const [num, setNum] = React.useState(0);

  const [alertError, setAlertError] = React.useState(false);
  const [alertOk, setAlertOk] = React.useState(false);
  const [msgAlert, setMsgAlert] = React.useState("");

  const [DatePickerAnno, setDatePickerAnno] = React.useState(false);
  const [DatePickerMese, setDatePickerMese] = React.useState(false);
  const [DatePickerGiorno, setDatePickerGiorno] = React.useState(false);

  const [valueData, setValueData] = React.useState(dayjs());
  const [dataFineAbbonamento, setDataFineAbbonamento] = React.useState("");

  const [visualizzaPagina, setVisualizzaPagina] = React.useState(false);
  const [isClickableButton, setIsClickableButton] = React.useState(true);

  const navigate = useNavigate();

  React.useEffect(() => {
    console.log(`idtipo ${idTipoUtente}`);
    if (idTipoUtente != Utenze.USER) {
      navigate("/");
    } else {
      setVisualizzaPagina(true);
    }
  }, []);

  React.useEffect(() => {
    console.log(`Bearer ${token}`);
    richiestaCampi();
  }, []);

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  const richiestaCampi = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");
    myHeaders.append(
      "Access-Control-Allow-Headers",
      "Access-Control-Allow-Headers , X-Requested-With, Content-Type, Authorization"
    );
    myHeaders.append(
      "Access-Control-Allow-Methods",
      "PUT, GET, POST, DELETE, OPTIONS"
    );
    myHeaders.append("Cache-Control", "no-cache, no-store, must-revalidate");
    myHeaders.append("Pragma", "no-cache");
    myHeaders.append("Authorization", `Bearer ${token}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(constant.RICHIESTACAMPI, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw navigate("/");
        } else {
          return response.json();
        }
      })
      .then((fieldList) =>
        setBookableField(fieldList.map((field) => field["NomeCampo"]))
      )
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  };

  const handleChange = (event) => {
    const value = Number(event.target.value) || 0;
    const name = event.target.name;

    setCostoAbbonamento(value);

    if (name === "Annuale") {
      setTipoAbbonamento("Annuale");
      setDatePickerAnno(false);
      setDatePickerMese(false);
      setDatePickerGiorno(true);
    }
    if (name === "Mensile") {
      setTipoAbbonamento("Mensile");
      setDatePickerAnno(false);
      setDatePickerMese(false);
      setDatePickerGiorno(true);
    }
    if (name === "Trimestrale") {
      setTipoAbbonamento("Trimestrale");
      setDatePickerAnno(false);
      setDatePickerMese(false);
      setDatePickerGiorno(true);
    }
    if (name === "Giornaliero") {
      setTipoAbbonamento("Giornaliero");
      setDatePickerAnno(false);
      setDatePickerMese(false);
      setDatePickerGiorno(true);
    }
  };

  const buttonCLickPagamento = () => {
    buttonCLick();
  };

  const createCheckoutSession = (
    dataInizioAbbonamento,
    dataFineAbbonamento
  ) => {
    // selectedFields contiene gli idCampo (index + 1)
    let arrCampi = [...selectedFields];

    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    var hh = today.getHours();
    var min = today.getMinutes();
    var sec = today.getSeconds();

    if (hh < 10) hh = "0" + hh;
    if (min < 10) min = "0" + min;
    if (sec < 10) sec = "0" + sec;

    today = yyyy + mm + dd + hh + min + sec;

    console.log(num);
    console.log(arrCampi);
    console.log("seconda data inizio "+dataInizioAbbonamento);
    console.log("seconda data fine "+dataFineAbbonamento);
    console.log(today);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");
    myHeaders.append(
      "Access-Control-Allow-Headers",
      "Access-Control-Allow-Headers , X-Requested-With, Content-Type, Authorization"
    );
    myHeaders.append(
      "Access-Control-Allow-Methods",
      "PUT, GET, POST, DELETE, OPTIONS"
    );
    myHeaders.append("Cache-Control", "no-cache, no-store, must-revalidate");
    myHeaders.append("Pragma", "no-cache");
    myHeaders.append("Authorization", `Bearer ${token}`);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        createCheckoutSession: 1,
        nomeProdotto: tipoAbbonamento,
        numeroCampi: num,
        idCampo: arrCampi[0], // primo campo selezionato
        dataInizio: dataInizioAbbonamento,
        dataFine: dataFineAbbonamento,
        tipoAbbonamento: tipoAbbonamento,
        confermato: "0",
        insDate: today,
        updDate: today,
      }),
      redirect: "follow",
    };

    fetch(constant.BASE_URL + "payment_init.php", requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw navigate("/");
        } else {
          return response.json().then((data) => {
            stripePromise.then((stripe) => {
              stripe.redirectToCheckout({
                sessionId: data.sessionId,
              });
            });
          });
        }
      })
      .then(handleResult)
      .catch((err) => {
        console.error("Errore nella createCheckoutSession", err);
        setMsgAlert("Errore durante l'inizializzazione del pagamento");
        setAlertError(true);
        setAlertOk(false);
        setIsClickableButton(true);
      });
  };

  const handleResult = (result) => {
    if (result && result.error) {
      console.log(result.error.message);
    }
  };

  const buttonCLick = () => {
    setIsClickableButton(false);
    setAlertError(false);
    setAlertOk(false);

    // VALIDAZIONI
    if (!selectedFields || selectedFields.length === 0) {
      setMsgAlert("Errore: selezionare almeno un campo");
      setAlertError(true);
      setIsClickableButton(true);
      return;
    }

    if (!tipoAbbonamento) {
      setMsgAlert("Errore: selezionare un periodo di abbonamento");
      setAlertError(true);
      setIsClickableButton(true);
      return;
    }

    if (!costoAbbonamento || costoAbbonamento <= 0) {
      setMsgAlert("Errore: costo abbonamento non valido");
      setAlertError(true);
      setIsClickableButton(true);
      return;
    }

    let _dataInizioAbbonamento = "";
    let _dataFineAbbonamento = "";

    if (tipoAbbonamento === "Giornaliero") {
      let annoInizio = valueData.year().toString();
      let meseInizio = (valueData.month() + 1).toString();
      let giornoInizio = valueData.date().toString();

      if (meseInizio < 10) {
        meseInizio = `0${meseInizio}`;
      }

      if (giornoInizio < 10) {
        giornoInizio = `0${giornoInizio}`;
      }

      _dataInizioAbbonamento = `${annoInizio}${meseInizio}${giornoInizio}000001`;
      _dataFineAbbonamento = `${annoInizio}${meseInizio}${giornoInizio}235959`;
    }

    if (tipoAbbonamento === "Mensile") {
      let annoInizio = valueData.year().toString();
      let meseInizio = (valueData.month() + 1).toString();
      let meseFine = (valueData.month() + 2).toString();
      let giornoInizio = valueData.date().toString();

      if (meseInizio < 10) {
        meseInizio = `0${meseInizio}`;
      }

      if (meseFine < 10) {
        meseFine = `0${meseFine}`;
      }

      if (giornoInizio < 10) {
        giornoInizio = `0${giornoInizio}`;
      }

      _dataInizioAbbonamento = `${annoInizio}${meseInizio}${giornoInizio}000001`;
      if (meseInizio === "02") {
        _dataFineAbbonamento = `${annoInizio}${(parseInt(meseInizio) + 1).toString().padStart(2, "0")}${giornoInizio}235959`;
      } else if (
        meseInizio === "04" ||
        meseInizio === "06" ||
        meseInizio === "09" ||
        meseInizio === "11"
      ) {
        _dataFineAbbonamento = `${annoInizio}${(parseInt(meseInizio) + 1).toString().padStart(2, "0")}${giornoInizio}235959`;
      } else {
        if (meseFine === "02" && giornoInizio > 28) {
          console.log(giornoInizio);
          giornoInizio = "28";
        } else if (
          (meseFine === "04" ||
            meseFine === "06" ||
            meseFine === "09" ||
            meseFine === "11") &&
          giornoInizio > 30
        ) {
          giornoInizio = "30";
        }
        _dataFineAbbonamento = `${annoInizio}${(parseInt(meseInizio) + 1).toString().padStart(2, "0")}${giornoInizio}235959`;
      }
    }

    if (tipoAbbonamento === "Trimestrale") {
        // L'utente sceglie solo mese e anno -> imposto giorno 1
        const dataInizio = valueData.startOf("month");   // <-- primo giorno del mese scelto
      
        let annoInizio = dataInizio.year().toString();
        let meseInizio = (dataInizio.month() + 1).toString();
        let giornoInizio = valueData.date().toString();

        
      
        // Calcolo data di fine: 90 giorni dopo il primo giorno del mese
        const dataFine = dataInizio.add(3, "month");
      
        let annoFine = dataFine.year().toString();
        let meseFine = (dataFine.month() + 1).toString().padStart(2, "0");

        if (meseInizio < 10) {
          meseInizio = `0${meseInizio}`;
        }

        if (giornoInizio < 10) {
          giornoInizio = `0${giornoInizio}`;
        }

        // Data inizio (formato richiesto)
        _dataInizioAbbonamento = `${annoInizio}${meseInizio}${giornoInizio}000001`;

        // console.log("mese fine prima dei controlli: " + meseFine);
        // console.log("giorno fine prima dei controlli: " + giornoFine);
        switch (meseFine) {
          case "02":
            if (giornoInizio > 28) giornoInizio = "28";
            break;
          case "04":
          case "06":
          case "09":
          case "11":
            if (giornoInizio > 30) giornoInizio = "30";
            break;
          default:
            if (giornoInizio > 31) giornoInizio = "31";
        }
        // Data fine (formato richiesto)
        console.log(`Data fine calcolata: ${annoFine}-${meseFine}-${giornoInizio}`);
        _dataFineAbbonamento = `${annoFine}${meseFine}${giornoInizio}235959`;
        console.log(`Data inizio: ${_dataInizioAbbonamento}, Data fine: ${_dataFineAbbonamento}`);
    }

    /*if (tipoAbbonamento === "Trimestrale") {
      let annoInizio = valueData.year().toString();
      let meseInizio = (valueData.month() + 1).toString();
      let meseFine = (valueData.month() + 3).toString();
      if (valueData.month() > 9) {
        meseFine = (12).toString();
        console.log(meseFine);
      }

      if (meseInizio < 10) {
        meseInizio = `0${meseInizio}`;
      }

      if (meseFine < 10) {
        meseFine = `0${meseFine}`;
      }

      _dataInizioAbbonamento = `${annoInizio}${meseInizio}01000001`;
      if (meseFine === "02") {
        _dataFineAbbonamento = `${annoInizio}${meseFine}28235959`;
      } else if (
        meseFine === "04" ||
        meseFine === "06" ||
        meseFine === "09" ||
        meseFine === "11"
      ) {
        _dataFineAbbonamento = `${annoInizio}${meseFine}30235959`;
      } else {
        _dataFineAbbonamento = `${annoInizio}${meseFine}31235959`;
      }
    }*/

    if (tipoAbbonamento === "Annuale") {
      let annoInizio = valueData.year().toString();
      let meseInizio = (valueData.month() + 1).toString();
      let giornoInizio = valueData.date().toString();

      let annoFine = (valueData.year() + 1).toString();

      if (meseInizio < 10) {
        meseInizio = `0${meseInizio}`;
      }

      if (giornoInizio < 10) {
        giornoInizio = `0${giornoInizio}`;
      }


      _dataInizioAbbonamento = `${annoInizio}${meseInizio}${giornoInizio}000001`;
      console.log(`Data inizio: ${_dataInizioAbbonamento}`);
      _dataFineAbbonamento = `${annoFine}${meseInizio}${giornoInizio}235959`;
      console.log(`Data fine prima dei controlli: ${_dataFineAbbonamento}`);
    }

    createCheckoutSession(_dataInizioAbbonamento, _dataFineAbbonamento);
  };

  const ColoredLine = ({ color }) => (
    <hr
      style={{
        color: color,
        backgroundColor: color,
        height: 1,
      }}
    />
  );

  return (
    <div
      style={{
        backgroundColor: "#E5E5E5",
        minHeight: "100vh",
      }}
    >
      {visualizzaPagina === true ? (
        <Grid>
          <InfoUser />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "calc(100vh - 65px)",
            }}
          >
            <Paper elevation={10} className="paperStyle">
              <Grid align="center" sx={{ p: 3 }}>
                <img src={imageLogoFidalIcona} width={120} alt="logoFidal" />
                <h2
                  style={{
                    marginTop: 12,
                    marginBottom: 12,
                  }}
                >
                  Scegli il tuo Campo
                </h2>

                {/* CAMPI */}
                <ToggleButtonGroup
                  value={selectedFields}
                  onChange={(event, newSelection) => {
                    setSelectedFields(newSelection);
                    setNum(newSelection.length);
                  }}
                  aria-label="selezione campo"
                >
                  {bookableField.map((item, index) => (
                    <ToggleButton
                      key={index}
                      value={index + 1}
                      aria-label={item}
                      sx={{
                        "&.Mui-selected": {
                          bgcolor: "primary.main",
                          color: "white",
                          "&:hover": {
                            bgcolor: "primary.dark",
                          },
                        },
                      }}
                    >
                      {item}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>

                <h2
                  style={{
                    marginTop: 12,
                    marginBottom: 0,
                  }}
                >
                  Scegli la data di inizio dell'abbonamento
                </h2>

                <div
                  className="datePickerContainer"
                  style={{
                    display: "flex",
                  }}
                >
                  {/* PERIODO */}
                  <div style={{ display: "flex" }}>
                    <FormControl style={{ width: "100%" }}>
                      <RadioGroup
                        aria-labelledby="periodo"
                        name="radio-buttons-group"
                      >
                        {[
                          { label: "Giornaliero", value: 5 },
                          { label: "Mensile", value: 10 },
                          { label: "Trimestrale", value: 25 },
                          { label: "Annuale", value: 90 },
                        ].map(({ label, value }) => (
                          <FormControlLabel
                            key={label}
                            value={value}
                            name={label}
                            control={<Radio onChange={handleChange} />}
                            label={label}
                            sx={{
                              m: 1,
                              width: "100%",
                              height: "56px",
                              border: "1px solid #5E2367",
                              borderRadius: 2,
                              bgcolor:
                                tipoAbbonamento === label
                                  ? "#5E236730"
                                  : "transparent",
                            }}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                  </div>

                  {/* CALENDARIO */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "start",
                      marginTop: 8,
                    }}
                  >
                    <LocalizationProvider
                      style={{ width: "100%" }}
                      dateAdapter={AdapterDayjs}
                      adapterLocale={"it"}
                    >
                      <Stack spacing={3} style={{ width: "100%" }}>
                        {DatePickerAnno && (
                          <DatePicker
                            views={["year"]}
                            label="Anno"
                            minDate={dayjs(dayjs())}
                            value={valueData}
                            onChange={(newValue) => {
                              setValueData(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField {...params} helperText={null} />
                            )}
                          />
                        )}
                        {DatePickerMese && (
                          <DatePicker
                            views={["year", "month"]}
                            label="Anno e mese di inizio"
                            minDate={dayjs(dayjs())}
                            value={valueData}
                            onChange={(newValue) => {
                              setValueData(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField {...params} helperText={null} />
                            )}
                          />
                        )}
                        {DatePickerGiorno && (
                          <StaticDatePicker
                            displayStaticWrapperAs="desktop"
                            openTo="day"
                            value={valueData}
                            onChange={setValueData}
                            sx={{
                              width: "100%",
                              "& .MuiPickersDay-root": {
                                "&.Mui-selected": {
                                  backgroundColor: "#5E2367",
                                  color: "white",
                                },
                              },
                            }}
                          />
                        )}
                      </Stack>
                    </LocalizationProvider>
                  </div>
                </div>

                <h2 style={{ marginTop: 12, marginBottom: 12 }}>
                  Totale: {num * costoAbbonamento} €
                </h2>

                <Button
                  disabled={!isClickableButton}
                  variant="contained"
                  margin="normal"
                  size="medium"
                  onClick={buttonCLickPagamento}
                  style={{
                    width: "80%",
                  }}
                >
                  Scegli piano
                </Button>
              </Grid>

              {alertError && (
                <Alert padding="20" severity="error">
                  {msgAlert}
                </Alert>
              )}
              {alertOk && <Alert severity="success">{msgAlert}</Alert>}
            </Paper>
          </div>
        </Grid>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Abbonamento;
